<ng-container *ngIf="selections.length > 0 || optional.length > 0">
    <ion-grid class="modifier-grid"
              [class.child]="child">
        <ion-row>
            <ng-container *ngFor="let option of selections; let last = last;">
                <ion-col [sizeXs]="sizeXs" [sizeSm]="sizeSm" [sizeMd]="sizeMd" [sizeLg]="sizeLg" [sizeXl]="sizeXl">
                    <bb-order-modifier-selection [selection]="option"
                                                 [modifiers]="modifiers"
                                                 [lines]="!last || optional.length > 0 ? 'none' : null"
                                                 [child]="child"
                                                 (modifiersChange)="modifiersChange.emit($event)"></bb-order-modifier-selection>
                </ion-col>
            </ng-container>
            <ng-container *ngIf="optional.length > 0">
                <ion-col [sizeXs]="sizeXs" [sizeSm]="sizeSm" [sizeMd]="sizeMd" [sizeLg]="sizeLg" [sizeXl]="sizeXl">
                    <ion-item [button]="true" [detail]="false" (click)="openOptionalModal = true">
                        <ion-grid>
                            <ion-row>
                                <ion-col>
                                    <ion-label>
                                        <span [class.title]="!child">Optional Modifiers</span>
                                        <p *ngIf="!optionalModifiers || optionalModifiers.length === 0" class="modifier-info">
                                            No Modifier
                                        </p>
                                        <p *ngFor="let modifier of optionalModifiers" class="modifier-info">
                                            {{ modifier.menuModifier.name }}
                                            <ng-container *ngIf="modifier.additionalPrice">({{ modifier.additionalPrice | currency }})</ng-container>
                                        </p>
                                    </ion-label>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-item>
                </ion-col>
            </ng-container>
        </ion-row>
    </ion-grid>
</ng-container>

<ion-modal *ngIf="openOptionalModal"
           [isOpen]="openOptionalModal"
           css-class="menu-modal"
           (didDismiss)="openOptionalModal = false">
    <ng-template>
        <modal-header title="Optional Modifiers"></modal-header>
        <ion-content class="ion-padding">
            <bb-select-buttons [options]="optional"
                               [selected]="optionalModifiers"
                               [sizeLg]="4"
                               [sizeXl]="3"
                               [sizeSm]="6"
                               (optionSelected)="multiSelectionChange($event)">
                <ng-template let-option #displayTemplate>
                    <ion-grid>
                        <ion-row>
                            <ion-col class="ion-text-center">{{ option.menuModifier.name }}</ion-col>
                        </ion-row>
                        <ion-row *ngIf="!!option.additionalPrice">
                            <ion-col class="ion-text-center">{{ option.additionalPrice | currency }}</ion-col>
                        </ion-row>
                    </ion-grid>
                </ng-template>
            </bb-select-buttons>
        </ion-content>
        <ion-footer class="ion-no-border">
            <ion-button color="dark" class="footer-button" (click)="this.openOptionalModal = false">
                Done
            </ion-button>
        </ion-footer>
    </ng-template>
</ion-modal>
